import { useState, useEffect } from "react";
import { Languages } from "lucide-react";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "or", label: "ଓଡ଼ିଆ" },
  { code: "hi", label: "हिंदी" },
];

export default function LanguageToggle() {
  const [current, setCurrent] = useState("en");

  useEffect(() => {
    const m = document.cookie.match(/googtrans=\/en\/(\w+)/);
    if (m && m[1] !== "en") setCurrent(m[1]);
  }, []);

  const clearTransCookie = () => {
    document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;
  };

  const setLang = (code) => {
    if (code === current) return;
    setCurrent(code);
    if (code === "en") {
      clearTransCookie();
      window.location.reload();
      return;
    }
    document.cookie = `googtrans=/en/${code}; path=/`;
    document.cookie = `googtrans=/en/${code}; path=/; domain=.${window.location.hostname}`;
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="flex items-center gap-1 bg-ink/5 rounded-full p-1" data-testid="language-toggle">
      <Languages size={13} className="text-ink/50 ml-1.5" />
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}-button`}
          className={`text-[11px] font-semibold px-2.5 py-1 rounded-full transition-colors duration-200 ${
            current === l.code ? "bg-ink text-sand" : "text-ink/60 hover:text-ink"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
